import ApiService from '@/services/core/api.service'

const DashboardService = {
  async getStatistics () {
    return ApiService.get('logistics-manager/dashboard/statistics')
  }
}

export default DashboardService
